<template>
  <div class="container">
    <div class="form-box">
      <div style="padding-right: 320px;">
        <el-steps
            :space="500"
            :active="userindex"
            finish-status="success"
            class="steps"
            align-center
        >
          <el-step title="填写资料"></el-step>
          <el-step title="手机验证"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
      </div>
      <div v-if="userindex == 1">
        <div class="title">填写资料</div>
        <el-upload
            class="upload-box"
            :show-file-list="false"
            :action="$uploadFileUrl"
            :multiple="false"
            name="file"
            :on-success="uploadHandle"
        >
          <!-- <div v-if="!photo" class="phote"></div> -->
          <img class="phote" v-if :src="photo?$imgUrl + photo:require('../../../assets/image/photo.jpg')" />
        </el-upload>
        <div class="message">
          <div>
            <span>昵称</span>
            <el-input v-model="nickName" placeholder="昵称"></el-input>
          </div>
          <div>
            <span>收货地址</span>
            <el-cascader
                :props="props"
                v-model="addIds"
                :options="regionList"
                placeholder="请选择设备地址"
                @change="addressChange"
            ></el-cascader>
          </div>
        </div>
        <div class="agreement">
          <el-checkbox v-model="checked"></el-checkbox>
          <span>已阅读并同意以下协议</span>
          <span style="color: #ff8a58"
          ><a @click="toLink(3)">《无忧用电隐私条款》</a
          ><a @click="toLink(5)">《无忧用电服务协议》</a></span
          >
        </div>
        <div class="button">
          <span></span>
          <div @click="step()">下一步</div>
        </div>
      </div>
      <div v-if="userindex == 2" class="phone">
        <div class="title">手机验证</div>
        <div class="message">
          <div>
            <span>手机号</span>
            <el-input v-model="phone" placeholder="请输入手机号"></el-input>
          </div>
          <div>
            <span></span>
            <div class="box">
              <el-input
                  placeholder="请输入短信验证码"
                  v-model="code"
              ></el-input>
              <div class="text" @click="sendCode">
                {{ codeText }}
              </div>
            </div>
          </div>
          <div>
            <span>密码</span>
            <el-input
                type="password"
                placeholder="设置密码"
                v-model="password"
                show-password
            ></el-input>

          </div>
          <span style="color: red;font-size: 10px;">
              *密码最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符
            </span>
        </div>
        <div class="button">
          <span></span>
          <div @click="setPassword()">下一步</div>
        </div>
      </div>
      <div v-if="userindex == 3" class="phone">
        <div class="success">
          <img src="../../../assets/image/z-1.png" />
          <p>完成</p>
        </div>
        <div class="button">
          <div @click="sumbit()">登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendCodeApi, registerApi } from "../../../http/api/user.js";
import { ProvinceList } from "../../../http/factory/add-eme.js";
//类型：厂商-0，用户-1，电工-2.
export default {
  data() {
    return {
      codeText: "发送验证码",
      userindex: 1,
      //头像
      photo: "",
      //昵称
      nickName: "",
      //地址
      province: "",
      city: "",
      county: "",
      //手机号
      phone: "",
      code: "",
      password: "",
      showMap: false,
      props: {
        label: "label",
        value: "id",
      },
      regionList: [],
      addIds: [],
      checked: true,
    };
  },
  created() {
    // 省市区
    ProvinceList().then((data) => {
      this.regionList = data;
    });
  },
  methods: {
    step() {
      if (!this.checked) {
        return this.$message("请勾选相关协议");
      }
      if (
          // this.photo == "" ||
          this.nickName == "" ||
          this.province == ""
      ) {
        return this.$message("请填写相关信息");
      }
      if (this.userindex++ > 2) this.userindex = 0;
    },
    setPassword() {
      let reg = /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/
      if (reg.test(this.password) == false) {
        return this.$message("密码最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符");
      }
      // if (!/^(?=.*[a-zA-Z])(?=.*[1-9]).{8,}$/.test(this.password)) {
      //   return this.$message("密码至少为8位必须为字母大小写加数字");
      // }
      if (this.phone == "" || this.cdoe == "" || this.password == "") {
        return this.$message("请补全相关信息在提交");
      }
      registerApi({
        phone: this.phone,
        password: this.password,
        code: this.code,
        name: this.nickName,
        type: 1,
        heading: this.photo,
        province: this.province,
        city: this.city,
        county: this.county,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "注册成功",
        });
      });
      if (this.userindex++ > 2) this.userindex = 0;
    },
    sendCode() {
      if (typeof this.codeText != "number") {
        this.codeText = 60;
        var time = setInterval((res) => {
          if (this.codeText > 0) {
            this.codeText--;
          }
          if(this.codeText == 0){
            clearInterval(time)
            this.codeText = '发送验证码';
          }
        }, 1000);

        //发送验证码
        sendCodeApi({
          phone: this.phone,
          type: "register",
        }).then((res) => {
          this.$message({
            type: "success",
            message: "短信发送成功",
          });
        });
      }
    },
    sumbit() {
      this.$router.push({
        path: "/",
      });
    },
    uploadHandle(file) {
      this.photo = file.fileName;
    },
    addressChange(value) {
      this.province = value[0];
      this.city = value[1];
      this.county = value[2];
    },
    toLink(id) {
      this.$router.push({
        path: "./agreement",
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style scoped lang="less" scoped>
.agreement {
  margin-left: 60px;
  width: 320px;
  display: inline-block;
  font-size: 15px;
  color: black;
  line-height: 30px;

  span {
    margin-left: 10px;

    a {
      cursor: pointer;
      margin: 0 5px;
    }
  }

  /deep/ .el-checkbox__inner::after {
    border-color: #ff8a58;
  }

  /deep/ .el-checkbox__inner {
    background-color: white;
    border-color: #ff8a58;
  }
}

.container {
  .form-box {
    width: 50%;
    margin: 0 auto;
    height: 550px;
    padding-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .steps {
      width: 800px;
      margin-left: 20%;
    }

    .title {
      text-align: center;
      font-size: 20px;
      margin: 20px 0 10px;
    }

    .success {
      display: flex;
      flex-direction: column;
      margin: 120px 0;
      align-items: center;

      img {
        width: 86px;
        height: 86px;
      }

      p {
        margin-top: 43px;
        font-size: 24px;
      }
    }

    .button {
      display: flex;
      margin-top: 30px;

      span {
        width: 56px;
        text-align: right;
        font-size: 14px;
      }

      div {
        width: 320px;
        height: 44px;
        margin-left: 10px;
        border-radius: 6px;
        background-color: #ff8855;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: white;
        cursor: pointer;
      }
    }

    .phone {
      .title {
        margin-bottom: 60px;
      }
    }

    .upload-box {
      display: flex;
      justify-content: center;

      .phote {
        width: 54px;
        height: 54px;
        background-color: #c4c4c4;
        border-radius: 50%;
        margin: 20px;
      }
    }

    .message {
      & > div {
        display: flex;
        margin-bottom: 15px;
        align-items: center;

        .box {
          width: 320px;
          margin-left: 10px;
          height: 44px;
          background-color: #f8f8f8;
          margin-bottom: 16px;
          border-radius: 6px;
          box-sizing: border-box;
          padding: 10px 0px;
          display: flex;

          .icon {
            width: 56px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #d9d9d9;

            img {
              width: 24px;
              height: 24px;
            }
          }

          .text {
            width: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-left: 1px solid #d9d9d9;
            font-size: 14px;
            color: #9b9b9b;

            &:hover {
              cursor: pointer;
            }
          }

          .el-input {
            flex: 1;

            /deep/ .el-input__inner {
              height: 24px;
              background-color: transparent;
              border-color: transparent;
            }
          }
        }

        span {
          width: 56px;
          text-align: right;
          font-size: 14px;
        }

        /deep/ .el-input {
          width: 320px;
          background-color: #f8f8f8;
          margin-left: 10px;
        }

        /deep/ .el-input__inner {
          background-color: #f8f8f8;
        }

        /deep/ .el-textarea {
          width: 320px;
          background-color: #f8f8f8;
          margin-left: 10px;
        }

        /deep/ .el-textarea__inner {
          background-color: #f8f8f8;
        }
      }
    }
  }
}
</style>
